import { render, staticRenderFns } from "./DatepickerFormat.vue?vue&type=template&id=22ba92b7&"
import script from "./DatepickerFormat.vue?vue&type=script&lang=js&"
export * from "./DatepickerFormat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports